export const LOCALES = {
  ENGLISH: "english",
  FRENCH: "french",
  SPANISH: "spanish",
  CHINESE: "chinese",
  KOREAN: "korean"
};
